// ! function() {
//     var sectionColumnTitle = document.querySelectorAll('[data-toggle-columnes]');
//     var textdesc= document.querySelector('.textes')
//     if (sectionColumnTitle.length) {
//       for (i = 0; i < sectionColumnTitle.length; i++) {
//         (function (i) {
//           sectionColumnTitle[i].addEventListener('click', (event) => {
//             var $this = event.currentTarget,
//             $content = $this.nextElementSibling;
//             $this.classList.toggle('is-clicked');
//             $content.classList.toggle('is-active');
//             textdesc.classList.toggle('hidden')
//             if ($content.style.maxHeight) {
//               $content.style.maxHeight = null;
//             } else {
//               $content.style.maxHeight = $content.scrollHeight + 'px';
//             }
//           });
//         })(i);
//       }
//     }
// }()

!function () {
  var sectionColumnTitle = document.querySelectorAll('[data-toggle-columnes]');

  sectionColumnTitle.forEach(function (btn) {

    btn.addEventListener('click', function () {

      var content = btn.nextElementSibling;
      btn.classList.toggle('is-clicked');
      content.classList.toggle('is-active');

      // ✅ 关键修复：只找当前模块
      var parent = btn.closest('.section') || btn.parentElement;
      var textdesc = parent.querySelector('.textes');

      if (textdesc) {
        // ❗不要 toggle（避免状态错乱）
        if (content.classList.contains('is-active')) {
          textdesc.classList.add('hidden');
        } else {
          textdesc.classList.remove('hidden');
        }
      }

      // height animation
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
      }

    });

  });
}();